import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import WhatIsSection from './components/WhatIsSection';
import FeatureCards from './components/FeatureCards';
import GuideHub from './components/GuideHub';
import ReviewSection from './components/ReviewSection';
import ShippingGuide from './components/ShippingGuide';
import LegitSection from './components/LegitSection';
import ArticleTeaser from './components/ArticleTeaser';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <WhatIsSection />
        <FeatureCards />
        <GuideHub />
        <ReviewSection />
        <ShippingGuide />
        <LegitSection />
        <ArticleTeaser />
        <CtaSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'What is Sugargoo Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Sugargoo Spreadsheet is an organized product discovery system that helps international shoppers find products faster, compare options, review quality information, and make smarter purchasing decisions across categories like sneakers, streetwear, hoodies, jackets, and accessories.',
                },
              },
              {
                '@type': 'Question',
                name: 'Is Sugargoo legit and safe to use?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Yes, Sugargoo has been operating for years with a proven track record in the international shopping agent industry. They maintain professional warehouses with quality inspection services, secure payment processing, and standard buyer protections.',
                },
              },
              {
                '@type': 'Question',
                name: 'How much does Sugargoo shipping cost?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Sugargoo shipping costs depend on package weight, destination country, chosen shipping line, and package dimensions. Multiple shipping methods are available with delivery times ranging from 5 to 20 days.',
                },
              },
            ],
          }),
        }}
      />
    </div>
  );
}